// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"2e5e575d","256":"82f1c85f","261":"0c93df0d","380":"56f25fab","395":"b48026ef","590":"0f6dfe75","631":"ad410e05","641":"7194dd26","694":"c68c2471","886":"e09c00ef","902":"042229e8","975":"9d6b2181","986":"b25084ad"}[chunkId] + ".chunk.js";
};